<div class="story-wrapper" *ngIf="currentStory">
    <div class="close-button" (click)="closeStory()">×</div>
    <div class="progress-bar-container">
      <div
        *ngFor="let story of stories; let i = index"
        class="progress-bar"
        [class.active]="i === currentStoryIndex"
        [class.completed]="i < currentStoryIndex"
      >
        <div class="progress" [style.width]="i === currentStoryIndex ? progressWidth : '100%'"></div>
      </div>
    </div>
    
    <div class="story-content">
      <video
        *ngIf="currentStory.type === 'video'"
        #videoPlayer
        (loadedmetadata)="startProgress()"
        (timeupdate)="updateProgress()"
        (ended)="nextStory()"
        autoplay
        muted
      >
        <source [src]="currentStory.url" type="video/mp4" />
      </video>
      <img
        *ngIf="currentStory.type === 'image'"
        [src]="currentStory.url"
        (load)="startProgress()"
        [style.display]="currentStory.type === 'image' ? 'block' : 'none'"
      />
    </div>
    <div class="navigation">
      <div class="prev" (click)="prevStory()"></div>
      <div class="next" (click)="nextStory()"></div>
    </div>
  </div>
  